import React from 'react'

const Loader = () => {
  return (
    <div className='loader-bg'>
        <div class="loader"></div>
    </div>
  )
}

export default Loader